module.exports = __webpack_public_path__ + "img/8-1.9f7028dd.png";